// External libraries
import { faEllipsisVertical } from "@fortawesome/sharp-solid-svg-icons";

// Internal
import { getDataTestId } from "../functions/data-test-ids";
import { Button } from "./button";

// CSS
import "./button-group.css";

function ButtonGroup(props) {
    const getButtons = () => {
        return props.Buttons.map((button, index) => {
            return (
                <Button
                    Style={props.Style}
                    key={index}
                    Visible={button.Visible}
                    Label={button.Label}
                    Title={button.Title}
                    Icon={button.Icon}
                    IconSpin={button.IconSpin}
                    Data={button.Data}
                    Disabled={button.Disabled}
                    MenuItems={button.MenuItems}
                    Class={button.Class}
                    DropDirection={button.DropDirection}
                    HideLabel={props.HideLabels === true || props.Collapsed === true}
                    HideIcon={props.HideIcons === true}
                    HideDropDownIndicator={button.HideDropDownIndicator === true || props.Collapsed === true}
                    HideMenuIcons={props.HideMenuIcons}
                    Danger={button.Danger}
                    Loading={button.Loading}
                    DataTestId={getDataTestId(props.DataTestId, button.DataTestId || button.Label)}
                    OnClick={button.OnClick} />
            );
        });
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    if (!props.Buttons || props.Buttons.length === 0) {
        return null;
    }

    if (props.Collapsed) {
        return (
            <Button
                Class={props.CollapseMenuClass}
                Icon={props.CollapsedIcon !== undefined ? props.CollapsedIcon : faEllipsisVertical}
                Label={props.CollapsedLabel}
                Title={props.CollapsedTitle}
                MenuItems={props.Buttons}
                HideDropDownIndicator={props.HideDropDownIndicator}
                DataTestId={getDataTestId(props.DataTestId, "collapsed")} />
        );
    }

    const getClassName = () => {
        let className = "eone-ui-button-group-container ";
        if (props.Class) className += props.Class;
        return className;
    };

    return (
        <div className={getClassName()}>
            {getButtons()}
        </div>
    );
}

export { ButtonGroup };
